module.exports = __webpack_public_path__ + "img/title3.27ab1726.png";